"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InputField = require("../InputField");
var _Calendar = require("../Calendar");
var _checkboxes = require("@vds/checkboxes");
var _toggles = require("@vds/toggles");
var _radioBoxes = require("@vds/radio-boxes");
var _radioButtons = require("@vds/radio-buttons");
var _RadioSwatch = require("../RadioSwatch");
var _excluded = ["type"];
/* istanbul ignore file */
var propTypes = {
  /**
   * The type of the Input that will render.
   */
  type: _propTypes["default"].oneOf(["checkbox", "toggle", "datePicker", "radioBox", "radioSwatch", "radioButton", "radio", "text", "number", "calendar", "inlineAction", "password", "creditCard", "tel", "date", "securityCode"]),
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool
};
var defaultProps = {
  type: "text",
  inverted: false
};

/**
 * @ignore
 */
var Input = function Input(_ref) {
  var type = _ref.type,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  switch (type) {
    case "checkbox":
      return /*#__PURE__*/_react["default"].createElement(_checkboxes.Checkbox, props);
    case "toggle":
      return /*#__PURE__*/_react["default"].createElement(_toggles.Toggle, props);
    case "calendar":
      return /*#__PURE__*/_react["default"].createElement(_Calendar.DatePicker, props);
    case "radioBox":
      return /*#__PURE__*/_react["default"].createElement(_radioBoxes.RadioBox, props);
    case "radioButton":
    case "radio":
      return /*#__PURE__*/_react["default"].createElement(_radioButtons.RadioButton, props);
    case "radioSwatch":
      return /*#__PURE__*/_react["default"].createElement(_RadioSwatch.RadioSwatch, props);
    case "number":
    case "text":
    case "inlineAction":
    case "password":
    case "creditCard":
    case "tel":
    case "date":
    case "securityCode":
      return /*#__PURE__*/_react["default"].createElement(_InputField.InputField, (0, _extends2["default"])({
        type: type
      }, props));
    default:
      console.warn("Warning: Native input type " + type + " is not supported");
      return /*#__PURE__*/_react["default"].createElement(_InputField.InputField, (0, _extends2["default"])({
        type: "text"
      }, props));
  }
};
Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
var _default = exports["default"] = Input;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/Input/Input.js
// module id = 1450
// module chunks = 0